import { memo, useCallback } from 'react'
import { replace } from 'connected-react-router'

import { Paper, Skeleton } from '@mui/material'

import { PageHeader, PageLayout } from '@collaborate-health/uikit'
import { onAddErrorNotification } from '@tabeeb/modules/notification/actions'

import Routes from '@tabeeb/routes'
import { useDispatch } from '@tabeeb/store'
import { trainingMaterialTitleFormatter } from '@tabeeb/shared/utils/text'
import { useTrainingMaterial } from '@tabeeb/modules/articles/hooks'
import ArticleContent, { ArticleContentSkeleton } from '@tabeeb/modules/articles/components/ArticleContent'

export interface TrainingMaterialViewPageProps {
  id: number
}

const TrainingMaterialViewPage: React.FC<TrainingMaterialViewPageProps> = ({ id }) => {
  const dispatch = useDispatch()

  const onError = useCallback(() => {
    dispatch(
      onAddErrorNotification({ message: trainingMaterialTitleFormatter.format('Failed to load training material') })
    )

    dispatch(replace(Routes.trainingMaterials))
  }, [dispatch])

  const { loading, trainingMaterial } = useTrainingMaterial({ id, onError })

  return (
    <PageLayout component={Paper} spacing='page' maxWidth='lg'>
      <PageHeader title={trainingMaterial?.Name || <Skeleton width={350} />} />

      {loading ? <ArticleContentSkeleton /> : <ArticleContent content={trainingMaterial?.Content} />}
    </PageLayout>
  )
}

export default memo(TrainingMaterialViewPage)

